module.exports = __webpack_public_path__ + "media/images/payment/logo_master-868fc432ff998238ba47e5cd2b1a18ab.gif";